import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGold"><Path d="M9.65234 12.9961L11.7471 18.8125L13.8418 12.9961L14.0195 12.5H20.4746L20.6523 12.9961L22.8145 19H0.679688L2.8418 12.9961L3.01953 12.5H9.47461L9.65234 12.9961Z" fill="currentColor"/><Path d="M15.4023 4.99609L17.5645 11H6.42969L8.5918 4.99609L8.76953 4.5H15.2246L15.4023 4.99609Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGold;
